import React from 'react';

export default class UploadItem 
{
    constructor (item) 
    {
        this.DownloadTemplateLink = './templates/Non_Sepa_Excel_Template.xlsx';
        if (item === undefined) 
        {
            this.file = null;
            this.exportId = null;
            return;
        }
        this.file = item.file ?? null;
        this.exportId = item.exportId;
    }


}
